import { Component, OnInit, EventEmitter, OnChanges, AfterViewInit, SimpleChange, Input, ViewChild, Output } from '@angular/core';
import { ModalDirective } from 'ng2-bootstrap/modal';
import { EmpresasService } from 'app/_services/empresas.service';
import { ConfirmationService } from 'primeng/primeng';

declare var jQuery:any;

@Component({
  selector: 'evidenciasequitativas',
  templateUrl: './evidenciasequitativas.component.html',
  styleUrls: ['./evidenciasequitativas.component.css']
})
export class EvidenciasequitativasComponent implements OnInit, AfterViewInit, OnChanges {


  @Input() _mostrarmodal: any;
  @ViewChild('staticModalRespuestas') public staticModalRespuestas: ModalDirective;
  @Input() _evidenciasModulo: any;

  @Output() onChangeModal = new EventEmitter<any>();

  mostrarmodal: boolean = false;
  listaEvidenciasModulo: any;
  listaEvidenciasEquitativas: any;
  evidenciaSeleccionada = 0;
  listaEnlaces: any = [];

  listaAllEvidencias: any = [];

  filterQueryEvidenciasEquitativas = '';
  filterQueryEvidenciasModulo = '';

  constructor(private empresasService: EmpresasService,
    private confirmationService: ConfirmationService) { }

  ngOnChanges(changes: { [propName: string]: SimpleChange }) {

    if (changes['_mostrarmodal']) {
      this.mostrarmodal = changes['_mostrarmodal'].currentValue;
    }

    if (changes['_evidenciasModulo']) {
      this.listaEvidenciasModulo = changes['_evidenciasModulo'].currentValue;
      this.listaEvidenciasEquitativas = changes['_evidenciasModulo'].currentValue;

    }
  }



  ngOnInit() {
  }

  ngAfterViewInit() {
    this.abrirModal();
  }

  abrirModal() {
    if (this.mostrarmodal) {
      this.staticModalRespuestas.show();
    }
  }

  cerrarModal(value: any) {

    this.staticModalRespuestas.hide();
    this.onChangeModal.emit(value);
  }



  setEvidenciaSelecionada(id_evidencia) {
    this.evidenciaSeleccionada = id_evidencia
    this.verEvidenciaEquitativa(id_evidencia);
    console.log('evidencia seleccionada:' + this.evidenciaSeleccionada);
  }



  checkEvidencia(event: any, evidencia: any) {
    console.log(evidencia.id_evidencia);
    let activo: number = 0;
    if (event.target.checked) {
      activo = 1;
    }

    if (activo == 1){
      this.checkListaEnlaces(evidencia.id_evidencia, activo);
    }else{
      this.setEvidenciaEquitativa(evidencia.id_evidencia,activo);
    }
    

  }

  setEvidenciaEquitativa(id_evidencia, activo) {

    let dataEnlaces: any;
    this.empresasService.setEnlacesEvidencia(this.evidenciaSeleccionada, id_evidencia, activo).subscribe(
      data => {
        dataEnlaces = data.json().evidencias;

      },
      err => { },
      () => {
        let enlaces = dataEnlaces;

        this.listaEnlaces.length = 0;

        for (let enlace of enlaces) {
          this.listaEnlaces[enlace.id_evidencia] = enlace.id_evidencia;
        }
        this.verEvidenciaEquitativa(this.evidenciaSeleccionada);
        console.log(this.listaEnlaces);
      }
    )


  }


  verEvidenciaEquitativa(id_evidencia) {


    this.evidenciaSeleccionada = id_evidencia;

    let dataEnlaces: any;
    this.empresasService.getEvidenciasEquitativas(id_evidencia).subscribe(
      data => {
        dataEnlaces = data.json().evidencias;

      },
      err => { },
      () => {
        let enlaces = dataEnlaces;
        this.listaEnlaces.length = 0;

        for (let enlace of enlaces) {
          this.listaEnlaces[enlace.id_evidencia] = enlace.id_evidencia;
        }

      }
    )

  }


  checkListaEnlaces(new_id_evidencia, activo) {

    this.empresasService.getAllEvidenciasEquitativas().subscribe(
      data => {
        this.listaAllEvidencias = data.json().evidencias;
        //console.log(this.listaAllEvidencias);

      },
      err => { },
      () => {

        if (this.listaAllEvidencias.findIndex(x => x.id_evidencia === this.evidenciaSeleccionada) > -1) {
          if (this.listaAllEvidencias.findIndex(x => x.id_evidencia === new_id_evidencia) > -1) {
            console.log('update valor 3');
            this.confirmationService.confirm({
              message: 'la evidencia ya está enlazada, se enlazarán todas las evidencias al conjunto ya creado',
              accept: () => {
                 this.setEvidenciaEquitativa(new_id_evidencia,3);
                 },
              reject: () => { 

                jQuery('#checkct_'+new_id_evidencia).prop("checked", false);

                }
            });
            
          } else {
            console.log('enlazamos normal valor 1');
            this.setEvidenciaEquitativa(new_id_evidencia,1);
          }

        } else {
          if (this.listaAllEvidencias.findIndex(x => x.id_evidencia === new_id_evidencia) > -1) {
            console.log('enlazamos normal selecionada y check al valor que ya exista valor 2');          
            this.confirmationService.confirm({
              message: 'la evidencia ya está enlazada, se enlazarán todas las evidencias al conjunto ya creado',
              accept: () => {
                this.setEvidenciaEquitativa(new_id_evidencia,2);
              },
              reject: () => {
                jQuery('#checkct_'+new_id_evidencia).prop("checked", false);
               }

            })

          } else {
            console.log('enlazamos normal selecionada y check valor 1');
            this.setEvidenciaEquitativa(new_id_evidencia,1);
          }

        }

      }
    )
  }


  confirm(texto,valor) {
    this.confirmationService.confirm({
      message: texto,
      accept: () => {
    
      }
    });
  }


}



// WEBPACK FOOTER //
// ./src/app/evidenciasequitativas/evidenciasequitativas.component.ts